<template>
    <router-view/>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style lang="scss">
    // Import Main styles for this application
    @import 'assets/scss/style';
    @import "assets/scss/vendor/font-gotham/gotham.css";
</style>
